<template>
  <a-modal :open="visible" @cancel="handleOk" :footer="null">
    <div class="content">
      <div>
        角色详情
      </div>
      <a-table
        class="mt20"
        rowKey="index"
        :columns="columns"
        :dataSource="tableData"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'action'">
            <a-button type="link" @click="onDelete(record.id)"
              >删除权限</a-button
            >
          </template>
        </template>
      </a-table>
    </div>
  </a-modal>
</template>

<script>
import { inject, toRefs } from 'vue'
import { user_delete_role_post } from 'server/modules/351.js'
import { message } from 'ant-design-vue'

export default {
  setup() {
    const modal = inject('modalState')

    const onDelete = id => {
      user_delete_role_post({ id }).then(res => {
        if (res.success) {
          message.success(res.data)
          modal.onVisible(modal.rowId)
          // modal.visible= false
        } else {
          message.error(res.data)
        }
      })
    }

    return {
      ...toRefs(modal),
      onDelete,
      columns: [
        // {
        //   title: 'ID',
        //   dataIndex: 'id',
        //   align: 'center',
        //   key: 'id'
        // },
        {
          title: '系统',
          dataIndex: 'menuSystemName',
          align: 'center',
          key: 'menuSystemName'
        },
        {
          title: '角色名称',
          dataIndex: 'roleName',
          align: 'center',
          key: 'roleName'
        },
        {
          title: '操作',
          key: 'action',
          align: 'center'
        }
      ]
    }
  }
}
</script>
